import { datalayerPush } from "./GTM";

class GlobalInteractions {
    constructor() {
        this.setupRecipeShare();
        this.setupEmailRecipe();
    }

    private setupRecipeShare() {
        const copyPageButton =
            document.getElementsByClassName("js-copy-page-url")["0"];
        if (copyPageButton) {
            copyPageButton.addEventListener("click", async () => {
                datalayerPush({
                    event: "recipe_share",
                    share_method: "copy_url",
                });

                try {
                    await navigator.clipboard.writeText(window.location.href);
                } catch {
                    return;
                }
            });
        }
    }

    private setupEmailRecipe() {
        const shareEmailLink =
            document.getElementsByClassName("js-share-email")["0"];
        if (shareEmailLink) {
            shareEmailLink.addEventListener("click", async () => {
                datalayerPush({
                    event: "recipe_share",
                    share_method: "email",
                });
            });
        }
    }
}

export default GlobalInteractions;
